import { gEnums } from '../../enums/globalEnums';
import { commitViewSettingsAction } from '../../viewSettings/actions/commitViewSettingsAction';
import { previewAction } from '../../viewSettings/actions/previewData';
import { dispatchConfirmationTypes, grts, responseReducers } from './reducerHelpers/dispatchProps';

const rts = {
  handleCommitViewSettingsAction: 'handleCommitViewSettingsAction',
  handleConfirmClose: 'handleConfirmClose',
  handleKillPreview: 'handleKillPreview',
  handlePreviewAction: 'handlePreviewAction',
  handlePreviewReady: 'handlePreviewReady',
  handleUpdating: 'handleUpdating',
  showPreview: 'showPreview',
  ...grts
}

export const settingsActionReducer = (state, action) => {

  const { fn_cls, database_fns, mainStorage, appSettings_fns, settingsParentContext, settingsAreaContext, logging, mainFunctions } = state
  const { handlers } = settingsParentContext ?? {}
  const { navigate, appSettings_handlers, firestore_handlers } = handlers ?? {}

  // componentContexts 
  const { settingsArea_state } = settingsAreaContext ?? {}
  const { settingsOriginType } = settingsArea_state ?? {}

  const {
    dispatch,
    isSolo,
    type,
  } = action

  const { handleUpdating } = settingsActionsHandlers(dispatch)

  switch (type) {

    case rts.handleCommitViewSettingsAction:
      const { actionName } = action.commitProps
      handleUpdating('Updating (' + actionName + ')')
      commitViewSettingsAction(fn_cls, database_fns, appSettings_fns, mainStorage, dispatch, firestore_handlers, action.commitProps, logging, mainFunctions)
      return { ...state }

    case rts.handlePreviewAction:
      previewAction(dispatch, action.previewProps, handleUpdating, rts.handlePreviewReady)
      return { ...state, previewClicked: action.previewClicked }

    case rts.handlePreviewReady:
      return { ...state, updating: false, previewInfo: action.previewInfo }

    case rts.handleConfirmClose:
      if (state.z) {
        appSettings_handlers.handleSetAppChange(true)
        switch (settingsOriginType) {
          case gEnums.settingsOriginTypes.app:
          case gEnums.settingsOriginTypes.page:
            navigate(-1)
            break;
          default:
          // nothing
        }
      }
      return { ...state, updating: false, confirmation: null, previewInfo: null, previewReady: false }

    case rts.showPreview:
      const { previewInfo: pri } = action
      delete pri.result
      delete pri.success
      return {
        ...state,
        previewInfo: pri,
        updating: false
      }

    case rts.handleKillPreview:
      return { ...state, previewClicked: null, }

    case rts.handleUpdating:
      return { ...state, updating: true, updatingCaption: action.updatingCaption ? action.updatingCaption : 'Fetching' }

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStartUpdate:
    case rts.updateError:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation, isSolo })

    default:
      alert('no viewItemDataActionsReducerTypes defined: ' + type)
      return state
  }
}

export const settingsActionsHandlers = (dispatch, state) => {
  return {
    handleCommitViewSettingsAction: (commitProps) => { dispatch({ type: rts.handleCommitViewSettingsAction, dispatch, commitProps }) },
    handleConfirmClose: () => { dispatch({ type: rts.handleConfirmClose, dispatch }) },
    handleKillPreview: () => { dispatch({ type: rts.handleKillPreview, dispatch }) },
    handlePreviewReady: (previewInfo) => { dispatch({ type: rts.handlePreviewReady, dispatch, previewInfo }) },
    handlePreviewAction: (previewClicked, previewProps) => { dispatch({ type: rts.handlePreviewAction, dispatch, previewClicked, previewProps }) },
    handleUpdating: (updatingCaption) => { dispatch({ type: rts.handleUpdating, dispatch, updatingCaption }) },
  }
}

export const settingsActionsInitialState = (initState) => {
  return { ...initState }
};

